import { Platform } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';
import { seller } from 'src/app/stores/product.store';
import { imageUrl } from 'src/environments/environment';

@Component({
  selector: 'app-shop-tag',
  templateUrl: './shop-tag.component.html',
  styleUrls: ['./shop-tag.component.scss'],
})
export class ShopTagComponent implements OnInit {
  @Input() seller: seller;
  imageUrl = imageUrl;

  constructor(public platform: Platform) {}

  ngOnInit() {}
}
